import { useTranslation } from 'react-i18next';
import type { i18n } from 'i18next';

import { type Locale, parseLocale } from '@/utils/localeFormatters';

/**
 * The locale every number on the dashboard is formatted in: the UI language, never the
 * browser's (owner decision U3). The charts already follow the UI language, so a card, a
 * table cell and the axis beside them print the same number the same way.
 *
 * Takes the instance from `useTranslation` rather than the global one, so a subtree under
 * its own `I18nextProvider` (the tests, for one) formats in that provider's language.
 */
export function dashboardLocale(instance: Pick<i18n, 'language'>): Locale {
    return parseLocale(instance.language);
}

/** `dashboardLocale` for the component's own translation instance. */
export function useDashboardLocale(): Locale {
    const { i18n: instance } = useTranslation();
    return dashboardLocale(instance);
}
